import { productPriceStyles as styles } from "@insite/content-library/Components/ProductPrice";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { commonHeading } from "@solveindustrial/WidgetExtensions/Components/SmallHeadingAndTextExtension";
import { css } from "styled-components";

styles.priceLabelText = {
    ...styles.priceLabelText,
    ...commonHeading,
};

styles.price = {
    ...styles.price,
    priceText: {
        ...styles.price?.priceText,
        variant: "p",
        weight: 400,
        css: css`
            ${styles.priceLabelText?.css}
            margin: 0;
        `,
    },
};

styles.priceWrapper = {
    ...styles.priceWrapper,
    css: css`
        ${styles.priceWrapper?.css}
        display: flex;
        align-items: center;
    `,
};